import { HttpRequest, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { faker } from '@faker-js/faker';
import { IClaimMessengerConversation } from 'app/claims/components/messenger/interfaces/claim-messenger-conversation.interface';
import { ApiEndpointService } from 'app/core/services/api-endpoint.service';
import { makeSyncStatus } from 'app/mocks/factories/claims/makes/make-sync-status';
import { makeEndpointMatcher } from 'app/mocks/utils/make-endpoint-matcher';
import { IMockRegistry } from 'app/mocks/interfaces/mock-registry.interface';

export function mockSyncConversation(
    apiEndpointService: ApiEndpointService,
): IMockRegistry {
    const endpointKey = 'claims.conversations.sync';
    const endpointMatcher = makeEndpointMatcher(endpointKey, apiEndpointService);

    return {
        method: 'POST',
        ...endpointMatcher,
        handler: (
            req: HttpRequest<unknown>,
            params: Record<string, string>,
            current?: IClaimMessengerConversation,
            _payload?: unknown,
        ) => {
            if (!current) {
                throw new Error(`No conversation cached for sync: ${ req.url }`);
            }

            current.syncStatus = makeSyncStatus({
                syncFailed: faker.datatype.boolean(0.1),  // 10% chance to simulate failure
            });

            return new HttpResponse({
                status: HttpStatusCode.Ok,
                body: current,
            });
        },
    };
}
